import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { HTTP_STATUS, useApiAppLegacy } from '@/shared/api';

/** 현재 비밀번호 불일치(verify 401) — feature 가 현재 비밀번호 필드 인라인 오류로 매핑. */
export class CurrentPasswordIncorrectError extends Error {
  constructor() {
    super('CURRENT_PASSWORD_INCORRECT');
    this.name = 'CurrentPasswordIncorrectError';
  }
}

/**
 * 비밀번호 변경 mutation — 2-step(구앱 정합): `POST /password/verify`(현재 비번 확인) → `PUT /password`(신규).
 * verify 401 = 현재 비번 오답 → `CurrentPasswordIncorrectError`(전역 세션만료 인터셉터는 "401+refresh 실패"
 * 에서만 발동하므로 단순 401 은 로컬 처리). 그 외 에러는 그대로 전파. 후처리는 caller(SRP).
 */
export function useChangePasswordMutation() {
  const api = useApiAppLegacy();

  return useMutation<void, Error, { current: string; next: string }>({
    mutationFn: async ({ current, next }) => {
      try {
        await api.user.verifyPassword({ account: { password: current } });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
          throw new CurrentPasswordIncorrectError();
        }
        throw error;
      }
      await api.user.updatePassword({ account: { password: next } });
    },
  });
}
